module.exports = __webpack_public_path__ + "img/img_helper_teleconsulta1.370bc84d.svg";